import {ComWixEcommerceValidationsSpiV1ViolationSeverity, ViolationFragment} from '../../../../gql/graphql';
import {ViolationTargetModel} from './ViolationTarget.model';

export enum ViolationSeverity {
  error = 'ERROR',
  warning = 'WARNING',
}

export class ViolationModel {
  public severity: ViolationSeverity;
  public description: string;
  public target?: ViolationTargetModel;

  constructor(params: ViolationModel) {
    this.severity = params.severity;
    this.description = params.description;
    this.target = params.target;
  }

  public static fromCheckoutV1(violation?: ViolationFragment) {
    return new ViolationModel({
      severity:
        violation?.severity === ComWixEcommerceValidationsSpiV1ViolationSeverity.ERROR
          ? ViolationSeverity.error
          : ViolationSeverity.warning,
      description: violation?.description ?? '',
      target: ViolationTargetModel.fromCheckoutV1(violation?.target),
    });
  }
}
